

<!--<div id="myCarousel" *ngIf="allHomeHeros" class="carousel slide mb-6" data-bs-ride="carousel">-->
<div id="myCarousel"  class="carousel slide mb-6" data-bs-ride="carousel">

  <div class="carousel-inner">
<!--    <div class="carousel-item active" *ngFor="let item of allHomeHeros; let i = index">-->
    <div class="carousel-item active" >
<!--      <a href="{{item.linkWhatsapp}}" target="_blank">-->
        <video
          autoplay
          loop
          muted
          style="width: 100%; background-color: white" >
          <source src="../assets/video/videoTestHome.mp4" type="video/mp4">
          Tu navegador no admite el elemento video.
        </video>


<!--      </a>-->
    </div>
  </div>
  <!--<button class="carousel-control-prev" type="button" data-bs-target="#myCarousel" data-bs-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#myCarousel" data-bs-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>-->
</div>






